module.exports = __webpack_public_path__ + "media/img/careers/why-work/why-work-img4-9e844f92a9e54a7e43f64d61a2a8c355.svg";